module.exports = __webpack_public_path__ + "img/light_red.2509799.png";